export const initPagination = () => {
    $('.page-link').click(function() {
        const idInput = 'current-page'
        const page = $(this).attr('data-page')
        const form = $('#' + idInput).val(page).attr('form')
        $('#' + form).submit()
    })
}
